export const RARITY_LABELS = {
  1: 'Common',
  2: 'Uncommon',
  3: 'Rare',
  4: 'Very Rare',
  5: 'Visceral',
  8: 'Event',
  11: 'Limited'
}

export const ITEM_CATEGORY_NAMES = {
  1: 'Key',
  3: 'Flashlight',
  5: 'Map',
  6: 'Med-Kit',
  7: 'Toolbox',
  8: 'Fog Vial'
}

const PROFILE_LIBRARY = {
  setup: {
    id: 'setup',
    label: 'Territory control',
    accent: '#f6c36a',
    tags: ['Generators', 'Pallets', 'Auras', 'ActionSpeed', 'Hindered', 'PowerRecovery'],
    perkRoles: ['regression', 'information', 'control'],
    summary: 'Protect a web of objectives, force detours, then convert setup into pressure.'
  },
  mobility: {
    id: 'mobility',
    label: 'High mobility',
    accent: '#64dcff',
    tags: ['Auras', 'Generators', 'Hooks', 'Exposed', 'Oblivious', 'MovementSpeed'],
    perkRoles: ['information', 'regression', 'chase'],
    summary: 'Find targets quickly and keep the map compressed between chases.'
  },
  stealth: {
    id: 'stealth',
    label: 'Stealth ambush',
    accent: '#b9a7ff',
    tags: ['Auras', 'Oblivious', 'Undetectable', 'Exposed', 'Healing', 'TerrorRadius'],
    perkRoles: ['information', 'stealth', 'snowball'],
    summary: 'Hide approach information and turn short windows into decisive downs.'
  },
  ranged: {
    id: 'ranged',
    label: 'Ranged pressure',
    accent: '#ff8b78',
    tags: ['Auras', 'Lockers', 'InjuredState', 'Exhausted', 'Hindered', 'Healing'],
    perkRoles: ['information', 'chase', 'reload'],
    summary: 'Keep line-of-sight information flowing and reduce time lost between shots.'
  },
  chase: {
    id: 'chase',
    label: 'Chase conversion',
    accent: '#ff6e83',
    tags: ['Pallets', 'Windows', 'Haste', 'Exposed', 'Obsession', 'BasicAttacks'],
    perkRoles: ['chase', 'information', 'snowball'],
    summary: 'Shorten each chase and immediately convert the down into new pressure.'
  },
  macro: {
    id: 'macro',
    label: 'Macro pressure',
    accent: '#86e5b1',
    tags: ['Generators', 'Hooks', 'Auras', 'Regression', 'Blocking', 'Healing'],
    perkRoles: ['regression', 'information', 'snowball'],
    summary: 'Trade a little lethality for reliable generator and hook tempo.'
  }
}

const PROFILE_BY_KILLER_ID = {
  1: 'setup',
  2: 'stealth',
  3: 'mobility',
  4: 'mobility',
  5: 'stealth',
  6: 'setup',
  7: 'setup',
  8: 'ranged',
  9: 'chase',
  10: 'macro',
  11: 'stealth',
  12: 'chase',
  13: 'mobility',
  14: 'chase',
  15: 'macro',
  16: 'stealth',
  17: 'setup',
  18: 'mobility',
  19: 'ranged',
  20: 'ranged',
  21: 'mobility',
  22: 'setup',
  23: 'ranged',
  24: 'macro',
  25: 'setup',
  26: 'ranged',
  27: 'stealth',
  28: 'macro',
  29: 'mobility',
  30: 'setup',
  31: 'macro',
  32: 'setup',
  33: 'setup',
  34: 'stealth',
  35: 'ranged',
  36: 'setup',
  37: 'mobility',
  38: 'mobility',
  39: 'chase',
  40: 'setup',
  41: 'stealth',
  42: 'setup',
  43: 'chase'
}

export const KILLER_PERK_STRENGTH = {
  corrupt_intervention: 96,
  scourge_hook_pain_resonance: 95,
  pain_resonance: 95,
  pop_goes_the_weasel: 93,
  deadlock: 91,
  grim_embrace: 90,
  no_way_out: 89,
  lethal_pursuer: 88,
  nowhere_to_hide: 88,
  barbecue_chilli: 86,
  eruption: 84,
  discordance: 83,
  dead_man_s_switch: 82,
  friends_til_the_end: 82,
  keep_them_waiting: 81,
  bamboozle: 80,
  tinkerer: 80,
  hex_devour_hope: 78,
  coup_de_grace: 77,
  sloppy_butcher: 75,
  a_nurse_s_calling: 74,
  brutal_strength: 73,
  agitation: 72,
  spies_from_the_shadows: 70,
  zanshin_tactics: 68,
  no_holds_barred: 91
}

export const PERK_ROLE_RULES = [
  { role: 'regression', keywords: ['generator', 'regress', 'blocked', 'damaging', 'repair'] },
  { role: 'information', keywords: ['aura', 'scream', 'killerinstinct', 'reveal', 'notification'] },
  { role: 'chase', keywords: ['pallet', 'window', 'vault', 'haste', 'lunge', 'exposed'] },
  { role: 'stealth', keywords: ['undetectable', 'oblivious', 'terror', 'stealth'] },
  { role: 'snowball', keywords: ['hook', 'dying', 'carrying', 'injured', 'healing'] },
  { role: 'control', keywords: ['totem', 'hex', 'obsession', 'chest', 'blocking'] },
  { role: 'reload', keywords: ['locker', 'reload'] }
]

export function getKillerProfile (killer) {
  const profileId = PROFILE_BY_KILLER_ID[killer && killer.id] || 'macro'
  return PROFILE_LIBRARY[profileId]
}

export function rarityLabel (rarity) {
  return RARITY_LABELS[rarity] || 'Special'
}

export function itemCategoryName (category) {
  return ITEM_CATEGORY_NAMES[category] || 'Item'
}

export function normalizeGameName (value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .toLowerCase()
}
